import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Telemetry before anything it is meant to capture, including a throw from a
// provider mounting below it. It imports `./env` on the way, so the environment is
// still validated first.
import './telemetry';
import './api';
import { AdminThemeProvider } from './AdminThemeProvider';
import { AuthProvider } from './auth/AuthProvider';
import { queryClient } from './query';
import { router } from './routes/router';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

/**
 * `AuthProvider` sits above the router because the route guard reads it, and above
 * nothing else that matters. Signing out clears the query cache as well as the
 * session — otherwise the next person to sign in on this machine starts with the
 * previous account's rows already on screen.
 */
createRoot(container).render(
  <StrictMode>
    <AdminThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider
          onSignOut={() => {
            queryClient.clear();
          }}
        >
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </AdminThemeProvider>
  </StrictMode>,
);
